angular.module(module.exports = 'ttb.issue.workLogDetails.workLogEditor.service', [])
    .factory('workLogEditorService', ['$uibModal',
        function ($uibModal) {

            function openModal(resolve) {
                const modalInstance = $uibModal.open({
                    component: 'workLogEditor',
                    appendTo: $('#issueDetails'),
                    size: 'lg',
                    backdrop: 'static',
                    resolve
                });
                return modalInstance.result.catch(e => { });
            }

            function editActivity({ activityLogId, teamId, isProjectIterationBased }) {
                return openModal({
                        activityLogId: () => {
                            return activityLogId;
                        },
                        teamId: () => {
                            return teamId;
                        },
                        isProjectIterationBased: () => {
                            return isProjectIterationBased;
                        }
                });
            }

            function addActivity({ issueId, teamId, isProjectIterationBased }) {
                return openModal({
                        issueId: () => {
                            return issueId;
                        },
                        teamId: () => {
                            return teamId;
                        },
                        creationMode: () => true,
                        isProjectIterationBased: () => {
                            return isProjectIterationBased;
                        }
                    });
            }

            return {
                editActivity,
                addActivity
            };
        }]);


// WEBPACK FOOTER //
// ./components/work-log-editor/work-log-editor.service.js